module.exports = __webpack_public_path__ + "static/media/laptop1.f8296473.jpg";